import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs';

class ReviewsPreview extends HTMLElement {
    constructor() {
        super();
        this.slider = document.querySelector('.tee-slider');

        let interval = setInterval(()=>{
            let isSlider = this.isSliderInitialized();
            if(isSlider){
                this.init()
                clearInterval(interval);
            }
        },500)
    }

    init(){
        const html = this.innerHTML;
        this.slider.insertAdjacentHTML('afterend', html);
        let openPopupBtn = document.querySelector('.reviews-preview__open-btn');
        let popup = document.querySelector('reviews-popup');
        if(openPopupBtn && popup){
            openPopupBtn.addEventListener('click',()=>{
                popup.open();
            })
        }
        this.remove();
    }

    isSliderInitialized(){
        let result;
        this.slider = document.querySelector('.tee-slider');
        if(this.slider){
            result = true;
        }else{
            result = false;
        }

        return result;
    }

    openPopup(){
        let popup = document.querySelector('reviews-popup');

        if(popup){
            popup.open();
        }
    }
  }

  customElements.define('reviews-preview', ReviewsPreview);




// POPUP


  class ReviewsPopup extends HTMLElement {
    constructor() {
        super();
        this.closeBtn = this.querySelector('.reviews-popup__close-btn');
        this.secondCloseBtn = this.querySelector('.reviews-popup__close-button');
        this.sliderElem = this.querySelector('.reviews-popup__slider-wrapper');
        this.slider = null;

        this.closeBtn.addEventListener('click',()=>{
            this.close()
        })

        this.secondCloseBtn.addEventListener('click',()=>{
            this.close();
            let productCustomizationElem = document.querySelector('.tee-customization-form');
            if(productCustomizationElem){
                var bodyRect = document.body.getBoundingClientRect(),
                elemRect = productCustomizationElem.getBoundingClientRect(),
                offset   = elemRect.top - bodyRect.top;
                offset = offset - 150;
                window.scrollTo(0, offset);
            }
        })

        this.sliderInit();
    }

    sliderInit(){
        this.slider = new Swiper(this.sliderElem,{
            slidesPerView: 'auto',
            spaceBetween: 12,
            navigation: {
                nextEl: '.reviews-popup__next-btn',
                prevEl: '.reviews-popup__prev-btn',
            },
            breakpoints: {
                750: {
                    spaceBetween: 16
                }
            }
        });
    }

    open(){
        this.classList.add('open');
        document.body.classList.add('scroll-off');
    }

    close(){
        this.classList.remove('open');
        document.body.classList.remove('scroll-off');
    }

  }

  customElements.define('reviews-popup', ReviewsPopup);
